module.exports = __webpack_public_path__ + "static/media/holidays-icon-blue.165dcd36.PNG";